import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 30,
  },
  section: {
    marginBottom: 10,
    break: 'avoid', 
  },
  spacing: {
    marginBottom: 10,
  },
  spacing2: {
    marginBottom: 4,
  },
  header: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
    marginBottom: 10,
    marginTop: 10,
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: 20,
    gap: 30,
  },
  title: {
    fontFamily: 'Times-Bold',
    fontSize: 14,
    textTransform: 'capitalize',
  },
  subtitle: {
    fontFamily: 'Times-Bold',
    fontSize: 12,
  },
  tableContainer: {
    break: 'avoid',
    marginBottom: 15,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid black",
    borderRight: 0,
    borderBottom: 0,
    break: 'avoid',
    wrap: false, // Prevent wrapping inside table
  },
  tableRow: {
    flexDirection: "row",
    break: 'avoid',
    wrap: false, // Prevent rows from splitting
    minHeight: 20, // Ensures rows stay together
  },
  tableCol: {
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 5,
    fontSize: 10,
  },
  tableColHead: {
    fontFamily: 'Times-Bold',
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 5,
    fontSize: 10,
  },
  tableHeader: {
    backgroundColor: "#d3d3d3",
    fontWeight: "bold",
  },
});

const TrialResults = ({ data }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.header}>
            <Text style={styles.title}>{data.trialName}, {data.trialLocation}</Text>
            <Text style={styles.title}>{moment.utc(data.date).format("MM/DD/YYYY")}</Text>
          </View>
          <Text style={[styles.title, styles.spacing]}>Trial Results</Text>

          {data.awards.length > 0 && (
            <View style={styles.tableContainer}> 
              <Text style={styles.title}>Awards</Text>
              <View style={styles.table}>
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <Text style={styles.tableColHead}>Award</Text>
                  <Text style={styles.tableColHead}>Handler</Text>
                  <Text style={styles.tableColHead}>Dog Name</Text>
                  <Text style={styles.tableColHead}>Breed</Text>
                </View>
                {data.awards.map((award, index) => (
                  <View style={styles.tableRow} key={index}>
                    <Text style={styles.tableCol}>{award.award}</Text>
                    <Text style={styles.tableCol}>{award.handler}</Text>
                    <Text style={styles.tableCol}>{award.dogName}</Text>
                    <Text style={styles.tableCol}>{award.breed}</Text>
                  </View>
                ))}
              </View>
            </View>
          )}

        {data.sit.length > 0 &&
            data.sit.map((search, index) => (
              search.data.length > 0 && (
                <View key={index} style={styles.section}>
                  <View style={styles.wrapper}>
                    <Text style={styles.title}>{search.search}</Text>
                    <Text style={styles.subtitle}>Entries: {search.entries}</Text>
                    <Text style={styles.subtitle}>Q Rate:{search.qRate}</Text>
                  </View>
                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableColHead}>Handler</Text>
                        <Text style={styles.tableColHead}>Dog Name</Text>
                        <Text style={styles.tableColHead}>Div</Text>
                        <Text style={styles.tableColHead}>Q/NQ</Text>
                        <Text style={styles.tableColHead}>Time</Text>
                      </View>
                      {search.data.map((entry, idx) => (
                        <View style={styles.tableRow} key={idx}>
                          <Text style={styles.tableCol}>{entry.handler}</Text>
                          <Text style={styles.tableCol}>{entry.dogName}</Text>
                          <Text style={styles.tableCol}>{entry.div}</Text>
                          <Text style={styles.tableCol}>{entry.qNq}</Text>
                          <Text style={styles.tableCol}>{entry.time}</Text>
                        </View>
                      ))}
                    </View>
                  </View>
                </View>
              )
            ))}
          {data.nonPremier.length > 0 &&
            data.nonPremier.map((search, index) => (
              search.data.length > 0 && (
                <View key={index} style={styles.section}>
                  <View style={styles.wrapper}>
                    <Text style={styles.title}>{search.search}</Text>
                    <Text style={styles.subtitle}>Entries: {search.entries}</Text>
                    <Text style={styles.subtitle}>Q Rate:{search.qRate}</Text>
                  </View>
                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableColHead}>Handler</Text>
                        <Text style={styles.tableColHead}>Dog Name</Text>
                        <Text style={styles.tableColHead}>Div</Text>
                        <Text style={styles.tableColHead}>Q/NQ</Text>
                        <Text style={styles.tableColHead}>NQ Reason</Text>
                        <Text style={styles.tableColHead}>Time</Text>
                        <Text style={styles.tableColHead}>Points</Text>
                        <Text style={styles.tableColHead}>Place</Text>
                      </View>
                      {search.data.map((entry, idx) => (
                        <View style={styles.tableRow} key={idx}>
                          <Text style={styles.tableCol}>{entry.handler}</Text>
                          <Text style={styles.tableCol}>{entry.dogName}</Text>
                          <Text style={styles.tableCol}>{entry.div}</Text>
                          <Text style={styles.tableCol}>{entry.qNq}</Text>
                          <Text style={styles.tableCol}>{entry.ngReason}</Text>
                          <Text style={styles.tableCol}>{entry.time}</Text>
                          <Text style={styles.tableCol}>{entry.points}</Text>
                          <Text style={styles.tableCol}>{entry.place}</Text>
                        </View>
                      ))}
                    </View>
                  </View>
                </View>
              )
            ))}
        </View>
      </Page>
    </Document>
  );
};

export default TrialResults;
